import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { AlertFilledIcon } from '../Icons';
import * as Colors from '../../theme/colors';
import BaseTypography from '../Text/BaseTypography';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(1.5),
    backgroundColor: Colors.HoverBackground,
    border: `1px solid ${Colors.HoverNonBorderBackground}`,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    gap: theme.spacing(1.5),
  },
  alertIcon: {
    fontSize: '14px',
  },
  contentWrapper: {
    width: '100%',
  },
}));

interface CalloutProps {
  hideIcon?: boolean;
  className?: string;
}
export const Callout: React.FC<CalloutProps> = React.memo(
  ({ children, hideIcon = false, className }) => {
    const classes = useStyles();

    return (
      <div className={clsx(className, classes.root)}>
        {!hideIcon && <AlertFilledIcon className={classes.alertIcon} />}
        <div className={classes.contentWrapper}>
          <BaseTypography>{children}</BaseTypography>
        </div>
      </div>
    );
  },
);
